import { Component, Input, OnInit, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { openDialogGetResult } from 'src/app/helpers/angular-helpers';
import { ConfirmDeleteData, openConfirmDeleteGetResult } from 'src/app/components/dialog.confirmDelete.component';
import { EntitySelectorData, EntitySelectorDialogComponent } from 'src/app/components/entities/entity-selector.dialog.component';
import { Exhibitor, exhibitorDisplayTypes, ExhibitorStand } from 'globals/store/exhibitors.data';
import { exhibitorStandIdsByProgramIdReselector } from 'src/app/store/reselectors/exhibitors.reselector';
import { ManageExhibitorData, ManageExhibitorDialogComponent } from './manage-exhibitor';
import { Dictionary } from '@ngrx/entity';
import { Program } from 'globals/store/programs.data';
import { StatusType } from 'globals/store/share.data';
import { Wrapper } from 'src/app/components/wrapper.component';
import { StatusWrapperComponent } from 'src/app/components/wrappers/status-wrapper.component';
import { CommonModule } from '@angular/common';
import { AddManageWrapperComponent } from 'src/app/components/wrappers/add-manage-wrapper.component';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { IdsToItemsPipe } from 'src/app/services/pipes/sortByIds.pipe';
import { SponsorCardComponent } from 'src/app/components/cards/sponsor-card.component';

@Component({
    selector: 'exhibitors',
    templateUrl: './exhibitors.html',
    styleUrls: ['../../components/performers/performers.component.scss', './exhibitors.scss', '../manage/entity-drag.scss'],
    standalone: true,
    imports: [StatusWrapperComponent, CommonModule, AddManageWrapperComponent, IconComponent, IdsToItemsPipe, SponsorCardComponent],
})
export class ExhibitorsComponent extends Wrapper<ExhibitorsComponent> implements OnInit {

  @Input() displayType: string | keyof typeof exhibitorDisplayTypes
  @Input() programId: string
  @Input() emptyText = 'No exhibitors'
  @Input() readOnly = true
  @Input() showBriefStatus = false
  @Input() fromManageDialog = true
  @Input() fromStandsId = null

  @Input() staticExhibitorIds = []
  @Input() staticExhibitorData: { exhibitors, exhibitorIdsByProgramIds, exhibitorStatusByProgramIds } = null // for snapshot view only <== not implemented for sponsors yet
  @Output() deleteExhibitor: EventEmitter<string> = new EventEmitter(); 
  displayTypes = exhibitorDisplayTypes
  exhibitorIds: string[] = []
  threeDotOptions = [{ name: 'Remove exhibitor from exhibitor stand', id: 'delete' }, { name: 'Manage exhibitor', id: 'manage' }]
  exhibitors: { [eId: string]: Exhibitor }
  noExhibitors = true
  programs: Dictionary<Program> = {}

  constructor(public changeDetectorRef: ChangeDetectorRef) {
    super()
    this.subProp(this.store.select('programs', 'entities'), 'programs')
  }

  ngOnInit() {
    // console.log({ displayType: this.displayType })

    this.subCallback(this.store.select('exhibitors', 'entities'), exhibitors => {
      this.exhibitors = exhibitors
      this.checkForExhibitors()
    })
  }

  dotMenuSelection({ event, option }, exhibitor: Exhibitor) {
    switch (option) {
      case 'delete':
        this.deleteFromExhibitorStandWithConfirm(exhibitor, event);
        break;
      case 'manage':
        this.manageExhibitor(exhibitor)
        break;
      default:
        console.log(`Missing selection [${option}] from three dot menu`)
        break;
    }
  }

  checkForExhibitors() { // Exhibitor ids are not removed from programs when exhibitors are removed from the event;  so we need workarounds like this
    if (this.exhibitors && this.exhibitorIds) {
      this.noExhibitors = !this.exhibitorIds.filter(id => !!this.exhibitors[id]).length
    }
  }


  changeStatus(exhibitor: Exhibitor, status: StatusType) {
    const confirmed = status === 'Confirmed'
    if (confirmed === !!exhibitor.confirmed) return
    exhibitor.confirmed = confirmed
    this.exhibitorService.updateExhibitor(exhibitor)    
  }



  async deleteFromExhibitorStandWithConfirm(exhibitor: Exhibitor, event) {
    const rect = event.target.getBoundingClientRect();
    const data: ConfirmDeleteData = {
      title: 'Remove ' + exhibitor.name + ' from this exhibitor stand',
      deleteButtonText: 'REMOVE',
      rect,
      bottomOffset: -45,
      dialog: this.dialog
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return
    this.deleteExhibitor.emit(exhibitor.id);
  }

  async manageExhibitor(exhibitor: Exhibitor) {
    const data: ManageExhibitorData = { exhibitorId: exhibitor.id, nested: this.fromManageDialog }
    this.changeDetectorRef.detach()
    await openDialogGetResult(this.dialog, ManageExhibitorDialogComponent, { autoFocus: false, disableClose: true, data, panelClass: 'full-screen-modal' })
    this.changeDetectorRef.reattach()
  }
}

